<template>
  <div class="list-item-cont">
    <v-list subheader>
      <v-subheader>장르 리스트</v-subheader>
      <v-list-tile
        v-for="i in items"
        :key="i.code"
        avatar
        class="list-item"
        @click="move(i)"
      >

        <div class="content">
          <div class="ko">{{i['genre-ko']}}</div>
          <div class="en">{{i['genre-en']}}</div>
        </div>

        <!--<v-spacer></v-spacer>-->
        <!--<div class="button-cont-desktop">-->
        <!--<v-btn @click="move(i.code)">이동</v-btn>-->
        <!--<v-btn @click="copy(i.code)">복사</v-btn>-->
        <!--</div>-->
        <!--<div class="button-cont-mobile">-->
        <!--<v-btn flat outline fab small @click="move(i.code)">-->
        <!--<v-icon>forward</v-icon>-->
        <!--</v-btn>-->
        <!--<v-btn flat outline fab small @click="copy(i.code)">-->
        <!--<v-icon>file_copy</v-icon>-->
        <!--</v-btn>-->
        <!--</div>-->
        <input
          style="display: none"
          type="text"
          :value="`https://netflix.com/browse/genre/${i.code}`"
          id="textBox"
          :ref="i.code">
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
    },
    methods: {
      move (i) {
        gtag('event', '버튼 클릭', {
          'event_category': '장르 선택',
          'event_label': `${i['genre-ko']}`,
          'value': i.code
        });
        window.open(`https://netflix.com/browse/genre/${i.code}`)
      },
      copy (code) {
        /* Get the text field */
        let textBox = this.$refs[code][0];

        /* Select the text field */
        textBox.select();

        /* Copy the text inside the text field */
        document.execCommand("copy");

        /* Alert the copied text */
        alert("Copied the text: " + textBox.value);
      }
    },
  }
</script>

<style lang="scss" scoped>
  .list-item-cont {
    .list-item {
      border-top: 1px solid #eeeeee;

      .content {
        padding: 4px 0;

        .ko {
          color: #333333;
        }

        .en {
          font-size: 12px;
          color: #777777;
        }

        @media all and (max-width: 500px) {

          .ko {
            font-size: 14px;
          }
        }
        @media all and (min-width: 501px) {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .ko {
            font-size: 18px;
          }
          .en {
            margin-left: 12px;
          }
        }

      }

      /*@media all and (max-width: 500px) {*/
      /*.button-cont-desktop {*/
      /*display: none;*/
      /*}*/
      /*}*/
      /*@media all and (min-width: 501px) {*/
      /*.button-cont-mobile {*/
      /*display: none;*/
      /*}*/
      /*}*/

      .flex {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
</style>